import Vue from 'vue';
import App from './App.vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import router from '@/router';
import VCalendar from 'v-calendar';

Vue.config.productionTip = false;

Vue.use(VCalendar);
Vue.use(Vuetify);

const vuetify = new Vuetify();

new Vue({
  render: (h) => h(App),
  router,
  vuetify,
}).$mount('#app');
